import React from 'react'
import { connect } from 'react-redux'
import { Form } from 'semantic-ui-react'

class RegionField extends React.PureComponent {
  render() {
    const { value, onChange, regions } = this.props

    const regionOptions = regions.map(region => ({
      key: region.id,
      text: region.name,
      value: region.id,
    }))

    return (
      <Form.Select
        required
        fluid
        label="Region"
        options={regionOptions}
        onChange={(e, data) => onChange('region', data.value)}
        value={value}
      />
    )
  }
}

const mapState = ({ regions }) => ({
  regions: regions.data
})

export default connect(mapState)(RegionField)



// WEBPACK FOOTER //
// ./src/components/drivers/fields/regionField.js